import BaseForumApi from "../BaseForumApi";

export default abstract class BasePostApi extends BaseForumApi {
	protected override getBaseUrl(params: Record<string, string>): string {
		return `${super.getBaseUrl(params)}/posts`;
	}
}
